
  import React from "react"
  import Component from "H:/Projects/be/BMC-UI/src/layouts/index.jsx"
  import data from "H:\\Projects\\be\\BMC-UI\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js